// controllers
import { UserController } from 'controllers';

export const handleAddComment = async (payload, customerId) => {
    await UserController.addComment(payload, customerId);
}
export const handleDeleteComment = async (customerId, commentId) => {
    await UserController.deleteComment(customerId, commentId);
}
export const getUserComments = async (customerId) => {
    return await UserController.getUserComments(customerId);
}
